













































































import Vue from 'vue';
import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { AttachDocuments } from '@/components/my-documents-components/attach-documents-component';
import {
  CloseFullscreenWrapper,
  TriggerRefreshError,
  FileUpload,
  DateFormat,
} from '@/mixins';
import { api, CLAIM_API_SUB_URLS, VAULT_API_SUB_URLS } from '@/api';
import { ExtendMixins, s3Instance } from '@/services';
import { dateFormat } from '@/constants';
import moment from 'moment';
import {
  MemberAccountResponseModel,
  PendingTransactionResponseModel,
  PostedTransactionResponseModel,
} from '@/@types/member';

interface Data {
  guidelines: string;
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
  encryptedPDFError: boolean;
  errorEncryptedPDFMessage: string;
  badFileError: boolean;
  errorBadFileMessage: string;
  // TODO typings
  files: any[];
  // TODO typings
  transaction: any;
  attachFromComputer: boolean;
  attachFromVault: boolean;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  TriggerRefreshError,
  FileUpload,
).extend({
  name: 'AttachDocumentsScreen',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      guidelines: this.params.guidelines,
      isLoading: false,
      showSuccessMessage: false,
      successMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
      encryptedPDFError: false,
      errorEncryptedPDFMessage: this.params.errorEncryptedPDFMessage,
      badFileError: false,
      errorBadFileMessage: this.params.errorBadFileMessage,
      files: [],
      transaction: this.params.transaction,
      attachFromComputer: false,
      attachFromVault: false,
    };
  },
  computed: {
    account(): MemberAccountResponseModel {
      return this.$store.getters.currentAccount(this.$route.params.id);
    },
    showGeneralError(): boolean {
      return (
        this.showErrorMessage && !(this.encryptedPDFError || this.badFileError)
      );
    },
    showEncryptedPDFError(): boolean {
      return this.showErrorMessage && this.encryptedPDFError;
    },
    showBadFileError(): boolean {
      return this.showErrorMessage && this.badFileError;
    },
    uploadedDocuments(): any {
      return this.files.filter((file) => {
        return file.vaultId === null || typeof file.vaultId === 'undefined';
      });
    },
    selectedDocuments(): any {
      return this.files.filter((file) => {
        return file.vaultId !== null && typeof file.vaultId !== 'undefined';
      });
    },
    category(): number {
      // If the account is undefined, we're assuming we're coming from the Unsubstantiated Claims page
      // and returning a category of 1 no matter what the product/account type is
      if (!this.account) {
        return 1;
      }

      const ACCOUNT_TYPE = this.account.productType;
      if (
        ACCOUNT_TYPE === 'FSA' ||
        ACCOUNT_TYPE === 'HSA' ||
        ACCOUNT_TYPE === 'HRA' ||
        ACCOUNT_TYPE === 'VEBA'
      ) {
        return 1;
      } else if (ACCOUNT_TYPE === 'DCAP') {
        return 4;
      }
      return 7;
    },
  },
  methods: {
    setSelectedFiles(files): void {
      this.files = files;
    },
    submitFiles(): void {
      this.isLoading = true;
      this.attachFiles();
    },
    async attachFiles(): Promise<any> {
      const NEW_DOCUMENT_IDS =
        this.uploadedDocuments.length === 0
          ? []
          // @ts-ignore
          : await this.uploadFiles(this.uploadedDocuments);
      const PAYLOAD = this.createSubstantiationPayload(NEW_DOCUMENT_IDS);
      const apiRequests = [];

      // BR-3.80 if transaction status = Needs Receipt invoke REST-031
      // getUnsubstantiatedClaim does not return transactionStatus, but returns swipeDate, if it exists then it is an unsubstantiated claim
      // we can use this to determine if claim Needs Receipt or not
      if (this.transaction.transactionStatus === 'Needs Receipt' || this.transaction.swipeDate) {
        apiRequests.push(api
          .put(
            `${CLAIM_API_SUB_URLS.claims}/hsa/${this.transaction.transactionId}/substantiations`,
            PAYLOAD,
          ));
      } else {
        if (this.attachFromComputer) {
          const newAttachments = PAYLOAD.filter((vaultRequest) => {
            return vaultRequest.imageId;
          });
          apiRequests.push(api
            .post(
              `${VAULT_API_SUB_URLS.members}/${this.$store.getters.user.memberId}/vault-data`,
              newAttachments,
            ));
        }
        if (this.attachFromVault) {
          PAYLOAD.map((vaultRequest) => {
            if (vaultRequest.vaultId) {
              apiRequests.push(api
                .patch(
                  `${VAULT_API_SUB_URLS.vaultData}/${vaultRequest.vaultId}`,
                  vaultRequest,
                ));
            }
          });
        }
      }

      await Promise.all(apiRequests)
          .then(() => {
            this.refreshTransactions();
          })
          .catch(() => {
            this.isLoading = false;
            this.showSuccessMessage = false;
            this.showErrorMessage = true;
            this.triggerRefreshError({
              message: [
                'attach-documents_text_substantiaion-error-message',
                'global_connection-error',
              ],
            });
          });
    },
    createSubstantiationPayload(uploadedDocumentToUUIDs): any {
      const VAULT_PAYLOAD =
        this.selectedDocuments && this.selectedDocuments.length > 0
          ? this.selectedDocuments.map((document) => {
            this.attachFromVault = true;
            return {
                vaultId: `${document.vaultId}`,
                imageFileName: document.fileName,
                imageFileNickname: document.fileNickname,
                uploadDate: document.uploadDate,
              };
            })
          : [];
      const UPLOAD_PAYLOAD = uploadedDocumentToUUIDs
        ? Object.entries(uploadedDocumentToUUIDs).map((nameAndUUID) => {
          this.attachFromComputer = true;
          return {
              imageFileName: nameAndUUID[0],
              imageFileNickname: nameAndUUID[0],
              imageId: nameAndUUID[1],
              uploadDate: moment().format(dateFormat),
            };
          })
        : [];
      const VAULT_DATA = [].concat(VAULT_PAYLOAD, UPLOAD_PAYLOAD);
      if (this.transaction.transactionStatus === 'Needs Receipt' || this.transaction.swipeDate) {
        return this.createUnsubstantiatedClaimRequest(VAULT_DATA);
      }
      return this.createStandardClaimRequest(VAULT_DATA);

    },
    createUnsubstantiatedClaimRequest(vaultData): any {
      const images = vaultData;

      return {
        memberId: this.$store.getters.user.memberId,
        startDate: moment(this.transaction.swipeDate || this.transaction.startDate).format(dateFormat),
        endDate: moment(this.transaction.swipeDate || this.transaction.endDate).format(dateFormat),
        providerName: this.transaction.providerName,
        patientName: this.transaction.patientName,
        amount: Math.abs(this.transaction.paymentAmount) || parseFloat(this.transaction.amount),
        noteToSelf: this.transaction.noteToSelf,
        images,
      };
    },
    createStandardClaimRequest(vaultData): any {
      return vaultData.map((image) => {
        return {
          memberId: this.$store.getters.user.memberId,
          imageId: image.imageId || null,
          vaultId: image.vaultId || null,
          fileName: image.imageFileName,
          uploadDate: image.imageId ? moment().format(dateFormat) : null,
          fileNickname: image.imageFileNickname,
          fromDate: this.transaction.startDate,
          toDate: this.transaction.endDate,
          category: this.category,
          patientName: this.transaction.patientName,
          providerName: this.transaction.providerName,
          amount: Math.abs(this.transaction.paymentAmount),
          isSubmitted: true,
          isMatched: false,
          matchId: this.transaction.transactionId,
          onlineClaimId: null,
          noteToSelf: this.transaction.noteToSelf,
        };
      });
    },
    refreshTransactions(): void {
      const PROMISES = [];

      if (this.$route.params.id) {
        PROMISES.push(this.$store.dispatch(
          'getAccountTransactions',
          this.$route.params.id,
        ));
      } else {
        PROMISES.push(this.$store.dispatch('getUnsubstantiatedClaims'));
        PROMISES.push(this.$store.dispatch('getHeaders'));
      }

      Promise.all(PROMISES)
        .then(() => {
          this.showSuccess();
        })
        .catch(() => {
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'attach-documents_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
    showSuccess(): void {
      // @ts-ignore
      this.confirmBeforeClose = false;
      this.showSuccessMessage = true;
      this.showErrorMessage = false;
      this.isLoading = false;
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
    AttachDocuments,
  },
});
